import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const BEIJING_TIMEZONE = 'Asia/Shanghai';

export const utcToBeijing = (utcTime) => {
  if (!utcTime) return null;
  return dayjs.utc(utcTime).tz(BEIJING_TIMEZONE);
};

export const beijingToUtc = (beijingTime) => {
  if (!beijingTime) return null;
  return dayjs.tz(beijingTime, BEIJING_TIMEZONE).utc();
};

export const formatDateTimeBeijing = (utcTime, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!utcTime) return null;
  return dayjs.utc(utcTime).tz(BEIJING_TIMEZONE).format(format);
};

export const formatDateBeijing = (utcTime, format = 'YYYY-MM-DD') => {
  if (!utcTime) return null;
  return dayjs.utc(utcTime).tz(BEIJING_TIMEZONE).format(format);
};

export const parseDateTimeBeijing = (dateTimeStr, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!dateTimeStr) return null;
  return dayjs.tz(dateTimeStr, format, BEIJING_TIMEZONE).utc().toISOString();
};

export const parseDateBeijing = (dateStr, format = 'YYYY-MM-DD') => {
  if (!dateStr) return null;
  return dayjs.tz(dateStr, format, BEIJING_TIMEZONE).startOf('day').utc().toISOString();
};

export const getCurrentUtc = () => {
  return dayjs.utc().toISOString();
};

export const getCurrentBeijing = () => {
  return dayjs().tz(BEIJING_TIMEZONE).format('YYYY-MM-DD HH:mm:ss');
};

export const toDayjsObject = (utcTime) => {
  if (!utcTime) return null;
  return dayjs.utc(utcTime).tz(BEIJING_TIMEZONE);
};

export const formatTimeAgo = (utcTime) => {
  if (!utcTime) return null;
  const now = dayjs();
  const time = dayjs.utc(utcTime).tz(BEIJING_TIMEZONE);
  const diff = now.diff(time, 'second');

  if (diff < 60) return '刚刚';
  if (diff < 3600) return `${Math.floor(diff / 60)}分钟前`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}小时前`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)}天前`;
  if (diff < 31536000) return `${Math.floor(diff / 2592000)}个月前`;
  return `${Math.floor(diff / 31536000)}年前`;
};